import React, { useMemo } from 'react'
import DataTable from '../../ui/DataTable/DataTable'
import Spinner from '../../ui/Spinner/Spinner'
import EmptyData from '../../ui/EmptyData/EmptyData'
import {
  formatCustomerName,
  formatCustomerTimestamp,
  formatOptionalText,
} from './customersUiUtils'

function CustomersTable({ rows, isLoading }) {
  const columns = useMemo(
    () => [
      {
        field: 'id',
        headerClassName: 'TableHeadCol',
        headerName: 'ID',
        width: 280,
        renderCell: (params) => (
          <span className="CustomersTable-IdCell">{params.row.id}</span>
        ),
      },
      {
        field: 'clientName',
        headerClassName: 'TableHeadCol',
        headerName: 'Клієнт',
        minWidth: 300,
        flex: 1,
        valueGetter: (params) => formatCustomerName(params.row.firstName, params.row.lastName),
        renderCell: (params) => formatCustomerName(params.row.firstName, params.row.lastName),
      },
      {
        field: 'phoneE164',
        headerClassName: 'TableHeadCol',
        headerName: 'Телефон',
        width: 160,
        renderCell: (params) => formatOptionalText(params.row.phoneE164),
      },
      {
        field: 'email',
        headerClassName: 'TableHeadCol',
        headerName: 'Email',
        width: 250,
        renderCell: (params) => formatOptionalText(params.row.email),
      },
      {
        field: 'createdAt',
        headerClassName: 'TableHeadCol',
        headerName: 'Дата реєстрації',
        width: 200,
        renderCell: (params) => formatCustomerTimestamp(params.row.createdAt),
      },
      {
        field: 'lastAuthAt',
        headerClassName: 'TableHeadCol',
        headerName: 'Останній вхід',
        width: 200,
        renderCell: (params) => formatCustomerTimestamp(params.row.lastAuthAt),
      },
    ],
    []
  )

  if (isLoading && !rows.length) {
    return (
      <div className="CustomersTable-State">
        <Spinner type="module" />
      </div>
    )
  }

  if (!isLoading && !rows.length) {
    return (
      <div className="CustomersTable-State">
        <EmptyData title="Клієнтів не знайдено" />
      </div>
    )
  }

  return (
    <div className="CustomersTable">
      <DataTable
        table={{
          rows,
          columns,
          disableSelectionOnClick: true,
          disableRowSelectionOnClick: true,
        }}
      />
    </div>
  )
}

export default CustomersTable
